import {
  AiAssistant,
  AiConnection,
  ASSISTANT_ID_CHAT_RECEPTIONIST,
  ASSISTANT_ID_MARKETER,
  ASSISTANT_ID_SALES_COACH,
  ASSISTANT_ID_VOICE_RECEPTIONIST,
  ConnectionType,
  CUSTOM_ASSISTANT_PLACEHOLDER_ID,
  DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON,
  DEFAULT_CONNECTION_PREFIX,
  WEBCHAT_ICON,
} from '@galaxy/ai-assistant';
import { AssistantType, Connection } from '@vendasta/ai-assistants';

export const NEW_WIDGET_CONFIGURATION_URL = 'inbox/widgets/new';
const DEFAULT_WIDGET_CONFIGURATION_URL = 'restricted/inbox-ai-webchat';

const assetPath = (basePath: string) =>
  window.location.hostname === 'localhost'
    ? `/assets/ai-assistant/${basePath}`
    : `https://vstatic-prod.apigateway.co/partner-center-client.9223372035080760057.prod/assets/ai-assistant/${basePath}`;

export const AI_DEFAULT_PARTNERS_ASSISTANT_WORKFORCE: AiAssistant[] = [
  {
    assistant: {
      id: ASSISTANT_ID_CHAT_RECEPTIONIST,
      name: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.CHAT_RECEPTIONIST.TITLE',
      type: AssistantType.ASSISTANT_TYPE_INBOX,
    },
    subtitleKey: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.CHAT_RECEPTIONIST.SUBTITLE',
    descriptionKey: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.CHAT_RECEPTIONIST.DESCRIPTION',
    decoration: {
      defaultAvatarIcon: DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON,
      avatarIconUrl: assetPath('avatars/ai-receptionist.jpg'),
      gradientColor: '#22C0CA',
    },
    isDefault: true,
    showConfigButtonOnDefault: true,
    autonomyRating: 3,
    order: 1,
  },
  {
    assistant: {
      id: ASSISTANT_ID_VOICE_RECEPTIONIST,
      name: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.VOICE_RECEPTIONIST.TITLE',
      type: AssistantType.ASSISTANT_TYPE_VOICE_RECEPTIONIST,
    },
    descriptionKey: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.VOICE_RECEPTIONIST.DESCRIPTION',
    decoration: {
      avatarIconUrl: assetPath('avatars/ai-receptionist.jpg'),
      gradientColor: '#A16EEF',
    },
    autonomyRating: 3,
    order: 2,
    isDefault: true,
    showConfigButtonOnDefault: false,
    computeCTA: (assistant: AiAssistant) => {
      // If the assistant is the default (i.e. no assistant has been provisioned), then the CTA is to upgrade
      if (
        assistant.isDefault ||
        !assistant.connections?.some((connection) => connection.connection.connectionType === ConnectionType.Voice)
      ) {
        return {
          label: 'UPGRADE_SUBSCRIPTION.UPGRADE_NOW',
          action: {
            pathCommands: ['/upgrade'],
            showButton: true,
          },
        };
      }
    },
  },
  {
    assistant: {
      id: ASSISTANT_ID_SALES_COACH,
      name: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.SALES_COACH.TITLE_V2',
      type: AssistantType.ASSISTANT_TYPE_UNSPECIFIED,
    },
    descriptionKey: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.SALES_COACH.DESCRIPTION',
    decoration: {
      avatarIconUrl: assetPath('avatars/ai-sales-assistant.jpg'),
      gradientColor: '#A16EEF',
    },
    isDefault: true,
    isDisabled: true,
    order: 3,
  },
  {
    assistant: {
      id: CUSTOM_ASSISTANT_PLACEHOLDER_ID,
      name: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.CUSTOM_ASSISTANT.TITLE',
      type: AssistantType.ASSISTANT_TYPE_CUSTOM,
    },
    descriptionKey: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.CUSTOM_ASSISTANT.DESCRIPTION',
    decoration: {
      avatarIconUrl: assetPath('avatars/ai-custom.png'),
      gradientColor: '#9066F7',
    },
    isDefault: true,
    order: 4,
  },
  {
    assistant: {
      id: ASSISTANT_ID_MARKETER,
      name: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.MARKETER.TITLE',
      type: AssistantType.ASSISTANT_TYPE_MARKETER,
    },
    descriptionKey: 'AI_ASSISTANT.WORKFORCE.DEFAULT_ASSISTANTS.MARKETER.DESCRIPTION',
    decoration: {
      gradientColor: '#9066F7',
    },
    isDefault: true,
    order: 5,
  },
];

export const AI_DEFAULT_PARTNERS_ASSISTANT_CONNECTIONS: AiConnection[] = [
  {
    connection: new Connection({
      id: DEFAULT_CONNECTION_PREFIX + 'webchat',
      name: 'Webchat',
      connectionTypeName: 'Webchat',
      iconUrl: WEBCHAT_ICON,
      connectionType: ConnectionType.WebchatWidget,
      supportedAssistantTypes: [AssistantType.ASSISTANT_TYPE_INBOX],
      configurationUrl: DEFAULT_WIDGET_CONFIGURATION_URL,
      isConnectionLocked: true,
    }),
    isDefault: true,
    cta: {
      action: {
        url: DEFAULT_WIDGET_CONFIGURATION_URL,
        showButton: true,
      },
    },
  },
];
